module.exports = __webpack_public_path__ + "media/images/undraw/matching/add_information-bc03976f3d87327ace826539f1106fe9.png";